"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brioRolesPermissions = exports.ProjectPermissions = exports.projectRolesDisplayNames = exports.ProjectRoles = exports.OrgPermissions = exports.orgRolesDisplayNames = exports.OrgRoles = void 0;
var OrgRoles;
(function (OrgRoles) {
    OrgRoles["Admin"] = "brio.org.role.admin";
    OrgRoles["Member"] = "brio.org.role.member";
})(OrgRoles = exports.OrgRoles || (exports.OrgRoles = {}));
exports.orgRolesDisplayNames = {
    [OrgRoles.Admin]: 'Admin',
    [OrgRoles.Member]: 'Member'
};
var OrgPermissions;
(function (OrgPermissions) {
    OrgPermissions["EditOrg"] = "brio.org.perm.edit";
})(OrgPermissions = exports.OrgPermissions || (exports.OrgPermissions = {}));
var ProjectRoles;
(function (ProjectRoles) {
    ProjectRoles["ProjectAdmin"] = "brio.project.role.admin";
    ProjectRoles["Contributor"] = "brio.project.role.contributor";
    ProjectRoles["Reviewer"] = "brio.project.role.reviewer";
})(ProjectRoles = exports.ProjectRoles || (exports.ProjectRoles = {}));
exports.projectRolesDisplayNames = {
    [ProjectRoles.ProjectAdmin]: 'Project Admin',
    [ProjectRoles.Contributor]: 'Contributor',
    [ProjectRoles.Reviewer]: 'Reviewer'
};
var ProjectPermissions;
(function (ProjectPermissions) {
    ProjectPermissions["ProjectAdministration"] = "brio.project.perm.administration";
    ProjectPermissions["EditFiles"] = "brio.project.perm.editFiles";
})(ProjectPermissions = exports.ProjectPermissions || (exports.ProjectPermissions = {}));
exports.brioRolesPermissions = {
    [ProjectRoles.ProjectAdmin]: [ProjectPermissions.ProjectAdministration, ProjectPermissions.EditFiles],
    [ProjectRoles.Contributor]: [ProjectPermissions.EditFiles],
    [ProjectRoles.Reviewer]: []
};
